import styled from "styled-components";

export const StyledGameContainer = styled.div`
  
  .game {
    position: relative;
    margin-top: 16px;
    box-shadow: 0 1px 4px 0 rgba(12, 12, 13, 0.1);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 600px;
    
    .game-image{
      height: 100%;
      width: 100%;
      position: absolute;
    }
    
    .audio-container{
      position: absolute;
      left: 0;
      bottom: 0;
    }
    
    .game-body{
      position: relative;
      z-index: 5;
    }

    .placeholder {
      transition: background-color 0.2s;
    }

    .placeholder.hover {
      background-color: #f0f0f0;
    }
    
    .background-image{
      border-radius: 20px;
      position: absolute;
      top: -16px;
    }
    
    .task-images, .choice-images{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`